/*
skillBars
*/
export default class SkillBars extends React.Component {
  constructor(props) {
    super(props);
    this.state = { collapsed: true };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ collapsed: false })
    }, 1000);
  }

  render() {
    const { collapsed } = this.state;
    const { hue, saturation, skills } = this.props;

    var content = (
      <div id="skillset" className={`skillbars ${collapsed ? 'collapsed' : ''}`}>
        <ul className="skills">
          {skills.map((skill, index) =>
            <li
              key={skill.type}
              style={{ width: `${skill.level}%`, backgroundColor: `hsl(${hue}, ${saturation}%, ${100 / (index + 3.5) }%)` }}
            >
              <p>{skill.type}<span>{skill.level}</span></p>
            </li>
          )}
        </ul>
      </div>
    );
    return content;
  }
}

// example usage
//   <SkillBars hue="300" saturation="40" skills={SKILLS} />,



// WEBPACK FOOTER //
// src/js/view/component/skillBars2.jsx